/* Buscador de la pagina de coleccion.
   Filtra los productos de ESA coleccion y reemplaza las tarjetas de la grilla en
   la misma pagina. No navega ni abre un desplegable.

   Shopify no acepta ?q= en las URLs de coleccion, asi que consultamos
   /search?view=cards (templates/search.cards.liquid) acotando por el filtro que
   la busqueda si respeta: filter.p.vendor en paginas de marca y
   filter.p.product_type en paginas de categoria. El template de coleccion deja
   ese par en data-scope-param / data-scope-value. */
(function () {
  'use strict';

  var form = document.querySelector('[data-collection-search]');
  var input = form && form.querySelector('[data-collection-search-input]');
  var grid = document.getElementById('collection-product-grid');
  var status = document.getElementById('collection-search-status');
  var pagination = document.getElementById('collection-pagination');
  /* El total de snippets/barra-listado.liquid es el de la grilla original:
     mientras se ven resultados del buscador se esconde, como la paginacion. */
  var totalBarra = document.querySelector('[data-barra-total]');
  if (!form || !input || !grid || !status) return;

  var scopeParam = form.getAttribute('data-scope-param') || '';
  var scopeValue = form.getAttribute('data-scope-value') || '';
  /* Sucursales elegidas con "Solo con stock" (snippets/barra-listado.liquid).
     La busqueda de Shopify no filtra por ese metafield: al 29-10-2026, con el
     parametro devolvia 0 resultados aunque en colecciones funcione. Por eso no
     se manda y las tarjetas sin stock en esas sucursales se sacan aca, con el
     data-sucursales que pone snippets/product-card-grid.liquid. */
  var sucursales = new URLSearchParams(location.search).getAll('filter.v.m.custom.sucursales_con_stock');
  var originalGrid = grid.innerHTML;
  var timer = null;
  var controller = null;
  var lastQuery = '';

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* El fetch trae product-card-grid.liquid ya con los data-item-* de
     tracking-marcas-ga4-gtm.md (Fase 2) puestos por Liquid; no hace falta
     reconstruir los datos del producto a mano, solo leerlos del DOM
     inyectado. Cada card tiene 2 elementos con data-gtm-item (el wrapper y
     el boton "Ver"): se deduplica por item-id. */
  function collectionTitle() {
    var dl = window.dataLayer || [];
    for (var i = 0; i < dl.length; i++) {
      if (dl[i] && dl[i].collection_title) return dl[i].collection_title;
    }
    return '';
  }

  function pushViewItemList(container, listName) {
    var seen = {};
    var items = [];
    var nodes = container.querySelectorAll('[data-gtm-item]');
    for (var i = 0; i < nodes.length; i++) {
      var d = nodes[i].dataset;
      if (!d.itemId || seen[d.itemId]) continue;
      seen[d.itemId] = true;
      items.push({
        item_id: d.itemId,
        item_name: d.itemName,
        item_brand: d.itemBrand,
        item_category: d.itemCategory,
        price: parseFloat(d.itemPrice || 0),
        index: items.length
      });
    }
    if (!items.length) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'view_item_list',
      ecommerce: { item_list_name: listName, items: items }
    });
  }

  function setStatus(html) {
    status.innerHTML = html;
    status.hidden = false;
    var clear = status.querySelector('.collection-search-clear');
    if (clear) clear.addEventListener('click', reset);
  }

  /* Vuelve a dejar la grilla original de la coleccion. */
  function reset() {
    if (controller) { controller.abort(); controller = null; }
    clearTimeout(timer);
    lastQuery = '';
    input.value = '';
    grid.innerHTML = originalGrid;
    if (typeof clmActivateCards === 'function') clmActivateCards(grid);
    if (pagination) pagination.style.display = '';
    if (totalBarra) totalBarra.hidden = false;
    status.hidden = true;
    status.innerHTML = '';
  }

  function run(q) {
    q = (q || '').trim();
    if (q === lastQuery) return;
    /* Con menos de 2 caracteres la busqueda de Shopify devuelve ruido. */
    if (q.length < 2) { reset(); return; }
    lastQuery = q;

    if (controller) controller.abort();
    controller = new AbortController();
    var mine = controller;

    setStatus('Buscando <strong>' + esc(q) + '</strong>…');

    var url = '/search?type=product&view=cards&options[prefix]=last&q=' + encodeURIComponent(q);
    if (scopeParam && scopeValue) {
      url += '&' + scopeParam + '=' + encodeURIComponent(scopeValue);
    }
    /* El filtro nativo de disponibilidad (el respaldo de "Solo con stock") si
       lo respeta la busqueda; el de sucursales va mas abajo. */
    var stock = new URLSearchParams(location.search).get('filter.v.availability');
    if (stock) url += '&filter.v.availability=' + encodeURIComponent(stock);

    fetch(url, { signal: mine.signal })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        if (mine !== controller) return;
        var box = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-search-cards]');
        if (!box) throw new Error('respuesta sin tarjetas');

        var total = parseInt(box.getAttribute('data-total'), 10) || 0;
        var shown = parseInt(box.getAttribute('data-shown'), 10) || 0;

        if (pagination) pagination.style.display = 'none';
        if (totalBarra) totalBarra.hidden = true;

        /* Con sucursales elegidas quedan solo las tarjetas con stock en alguna
           de ellas. Se filtra sobre lo que trajo la busqueda (24 como mucho). */
        var conStock = null;
        if (total && shown) {
          grid.innerHTML = box.innerHTML;
          if (sucursales.length) {
            conStock = 0;
            grid.querySelectorAll('.product-card').forEach(function (card) {
              var tiene = (card.getAttribute('data-sucursales') || '').split('|');
              var sirve = sucursales.some(function (s) { return tiene.indexOf(s) !== -1; });
              if (sirve) conStock++; else card.parentNode.removeChild(card);
            });
          }
        }

        if (!total || !shown || conStock === 0) {
          grid.innerHTML = '<div class="collection-search-empty">'
            + '<h3>Sin resultados' + (conStock === 0 ? ' con stock' : '') + ' para "' + esc(q) + '"</h3>'
            + (conStock === 0
              ? '<p>Hay ' + shown + ' sin stock: quita "Solo con stock" para verlos.</p>'
              : '<p>Prueba con un SKU, un código de fabricante o menos palabras.</p>')
            + '</div>';
          setStatus('Sin coincidencias' + (conStock === 0 ? ' con stock' : '') + ' para <strong>' + esc(q) + '</strong>'
            + '<button type="button" class="collection-search-clear">Limpiar</button>');
          return;
        }

        if (typeof clmActivateCards === 'function') clmActivateCards(grid);
        pushViewItemList(grid, collectionTitle() ? collectionTitle() + ' · búsqueda' : 'busqueda_coleccion');

        /* search.cards.liquid pagina de a 24: si hay mas, lo decimos en vez de
           fingir que esto es todo. */
        var msg = conStock === null
          ? 'Mostrando <strong>' + shown + '</strong> de <strong>' + total + '</strong>'
            + ' resultado' + (total === 1 ? '' : 's') + ' para <strong>' + esc(q) + '</strong>'
          : 'Mostrando <strong>' + conStock + '</strong> con stock de los primeros <strong>' + shown + '</strong>'
            + ' resultado' + (shown === 1 ? '' : 's') + ' para <strong>' + esc(q) + '</strong>';
        if (total > shown) msg += ' · afina la búsqueda para ver el resto';
        msg += '<button type="button" class="collection-search-clear">Limpiar</button>';
        setStatus(msg);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (mine !== controller) return;
        setStatus('No se pudo completar la búsqueda. '
          + '<button type="button" class="collection-search-clear">Limpiar</button>');
      });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    clearTimeout(timer);
    lastQuery = '';
    run(input.value);
  });

  input.addEventListener('input', function () {
    clearTimeout(timer);
    var value = this.value;
    timer = setTimeout(function () { run(value); }, 350);
  });

  /* Escape limpia, como en cualquier buscador. */
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && this.value) { e.preventDefault(); reset(); }
  });
})();
